import { DiagramDefinition } from "../types";

export const m002Definition: DiagramDefinition = {
  id: "M-002",
  title: "Dual-Database File Architecture",
  description:
    "Solarch application controller architecture managing two SQLite databases: data.db (containing _collections, users, and custom tables) and auxiliary.db (containing _logs, _audit, _rateLimits, and session tables).",
  viewBox: "0 0 800 440",
  nodes: [
    { id: "Engine", kind: "service", label: "Solarch Engine", subtext: "App Controller", position: [400, 60], size: [180, 50] },
    { id: "DataManager", kind: "service", label: "Data Controller", subtext: "Primary DB Manager", position: [240, 160], size: [160, 48] },
    { id: "AuxManager", kind: "service", label: "Auxiliary Controller", subtext: "System DB Manager", position: [560, 160], size: [170, 50] },
    { id: "DataDB", kind: "database", label: "pb_data/data.db", subtext: "Primary Storage", position: [240, 260], size: [170, 50] },
    { id: "AuxDB", kind: "database", label: "pb_data/auxiliary.db", subtext: "System Storage", position: [560, 260], size: [170, 50] },
    
    // DataDB Tables
    { id: "CollTable", kind: "service", label: "_collections", subtext: "Schema Table", position: [130, 370], size: [120, 50] },
    { id: "UserTable", kind: "service", label: "users", subtext: "Auth Table", position: [250, 370], size: [100, 50] },
    { id: "RecordTables", kind: "service", label: "Custom Tables", subtext: "App Collections", position: [370, 370], size: [125, 50] },

    // AuxDB Tables
    { id: "LogTable", kind: "service", label: "_logs", subtext: "HTTP Logs", position: [480, 370], size: [90, 50] },
    { id: "AuditTable", kind: "service", label: "_audit", subtext: "Audit Trail", position: [580, 370], size: [90, 50] },
    { id: "RateLimitTable", kind: "service", label: "_rateLimits", subtext: "Cache Limits", position: [680, 370], size: [110, 50] },
  ],
  edges: [
    { id: "e1", source: "Engine", target: "DataManager", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e2", source: "Engine", target: "AuxManager", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e3", source: "DataManager", target: "DataDB", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e4", source: "AuxManager", target: "AuxDB", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e5", source: "DataDB", target: "CollTable", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e6", source: "DataDB", target: "UserTable", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e7", source: "DataDB", target: "RecordTables", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e8", source: "AuxDB", target: "LogTable", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e9", source: "AuxDB", target: "AuditTable", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e10", source: "AuxDB", target: "RateLimitTable", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
  ],
};
